import { useSnapshot } from "valtio"
import {
    contractsStore
} from '../state/CommonState'
import Utils from "../util/Utils"
import { configStore } from "../state/CommonState"
export default function LCLChargeClientView() {
    useSnapshot(contractsStore)
    const rec = contractsStore.current
    const Tn = ({ i, name }) => {
        const e = rec.chargesList[i]
        if (name === 'total') {
            return (
                <span style={{ textAlign: 'right' }}>{Utils.N(e[name], e.currency)}</span>
            )
        } else {
            //console.log(name, e.currency, e[name])
            let num = e[name]
            num = isNaN(num) ? 0.0 : Number(num)
            return num != 0 ? <span>{Utils.N(num, e.currency)}</span> : <></>
        }
    }
    let grandTotal = 0.0
    rec.chargesList.map(e => {
        let erate = configStore.getExchangeRateinr(e)
        if (!erate || erate === 0) erate = 1.0
        grandTotal += e.total * erate
    })
    let counter = 1
    return (
        <>
            <hr />
            <div className="table-container">
                <table className="table is-bordered is-striped is-narrow is-hoverable ">
                    <thead>
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th colSpan='4' className="has-text-centered">Per Unit</th>
                            <th></th>
                            <th></th>
                        </tr>
                        <tr>
                            <th>#</th>
                            <th style={{ textAlign: 'center' }}>Charge Description</th>
                            <th>Currency</th>
                            <th style={{ textAlign: 'center' }}>Per CBM</th>
                            <th style={{ textAlign: 'center' }}>Per Ton</th>
                            <th style={{ textAlign: 'center' }}>Minimum</th>
                            <th style={{ textAlign: 'center' }}>Maximum</th>
                            <th style={{ textAlign: 'center' }}>Per Shipment</th>
                            <th style={{ textAlign: 'right' }}>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            rec.chargesList.map((e, i) => (
                                <tr key={e.id}>
                                    <td >{counter++}</td>
                                    <td>{e.chargeDescription}</td>
                                    <td>{e.currency}</td>
                                    <td style={{ textAlign: 'center' }}><Tn i={i} name='perCBM' /></td>
                                    <td style={{ textAlign: 'enter' }}><Tn i={i} name='perTon' /></td>
                                    <td style={{ textAlign: 'center' }}><Tn i={i} name='minimum' /></td>
                                    <td style={{ textAlign: 'center' }}><Tn i={i} name='maximum' /></td>
                                    <td style={{ textAlign: 'center' }}><Tn i={i} name='perShipment' /></td>
                                    <td style={{ textAlign: 'right' }}><Tn i={i} name='total' /></td>
                                </tr>
                            )
                            )
                        }
                        <tr>
                            <td colSpan={8}></td>
                            <td style={{ textAlign: 'right' }}><strong>{Utils.N(grandTotal)}</strong></td>
                        </tr>
                        <tr>
                            <td colSpan={9} style={{ textAlign: 'right' }}>Taxes & Duties additional, as applicable</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
}
